module.exports = __webpack_public_path__ + "static/media/jasmine.50875715.png";